import React from 'react';
import { TolgeeAppProvider } from '../lib/tolgee/tolgee-provider';

type TolgeeWrapperProps = {
  children: React.ReactNode;
  locale?: string;
};

export const TolgeeWrapper = ({ 
  children, 
  locale = 'es'
}: TolgeeWrapperProps) => {
  console.log('🔧 [TolgeeWrapper] Montando con locale:', locale);
  
  return (
    <TolgeeAppProvider locale={locale}>
      {children}
    </TolgeeAppProvider>
  );
}; 